/**
 * Gets the effective current path, checking session storage for restored routes
 * when on the base URL after a redirect
 */
export const getEffectiveCurrentPath = (): string => {
  const currentPath = window.location.pathname;
  
  // If we're on the base path, check for stored route
  if (currentPath === '/') {
    const storedRouteData = sessionStorage.getItem('ejw_original_route');
    if (storedRouteData) {
      try {
        const { route, timestamp } = JSON.parse(storedRouteData);
        const now = Date.now();
        const thirtyMinutes = 30 * 60 * 1000; // 30 minutes in milliseconds
        
        // Check if stored route is still valid (less than 30 minutes old)
        if (now - timestamp < thirtyMinutes) {
          return route;
        } else {
          // Clear expired session storage
          sessionStorage.removeItem('ejw_original_route');
        }
      } catch (e) {
        // Clear invalid session storage
        sessionStorage.removeItem('ejw_original_route');
      }
    }
  }
  
  return currentPath;
};
